module.exports = __webpack_public_path__ + "img/logo.b0c75641.png";